
























































































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';

import {
  ContractPeriodEnum,
  DataBus,
  DataTableRequest,
  ResponseCodeEnum,
  InputError,
  EnumObject,
  Customer,
  TireStoringContract,
  TireStoringInfo,
  TireBrand,
  TireTypeEnum,
} from '@/models';
import { tireStoringContractService, tireBrandService, toastService } from '@/services';

import TireInfoCard from '@/components/tire/info/TireInfoCard.vue';

@Component({
  components: {
    TireInfoCard,
  },
})
export default class TireConfirmInfo extends Vue {
  @Prop() public isEdit!: boolean;
  @Prop() public isConfirm!: boolean;
  @Prop() public isSwitch!: boolean;
  @Prop() public tireContract!: TireStoringContract;
  @Prop() public tireContractList!: TireStoringContract[];

  private showTabSummer: boolean = true;
  private showTabWinter: boolean = true;
  private tireBrandDefaultOption: TireBrand = new TireBrand();
  private tireScratchOptions: EnumObject[] = [];
  private tireIrregularWearOptions: EnumObject[] = [];
  private tabIndex: number = 1;
  private activeTabSummer: boolean | null = null;
  private activeTabWinter: boolean | null = null;

  private created() {
    tireStoringContractService.getTireScratch()
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          this.tireScratchOptions = res.data.data.map((option) => {
            if (option.text) {
              option.text = this.$t(option.text).toString();
            }
            return option;
          });
        }
      });
    tireStoringContractService.getTireIrregularWear()
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          this.tireIrregularWearOptions = res.data.data.map((option) => {
            if (option.text) {
              option.text = this.$t(option.text).toString();
            }
            return option;
          });
        }
      });
    this.setDefaultTireBrand();
    if (this.tireContract.period === ContractPeriodEnum.SIX_MONTH) {
      this.showTabSummer = this.tireContract.tireType === TireTypeEnum.SUMMER;
      this.showTabWinter = this.tireContract.tireType === TireTypeEnum.WINTER;
    } else {
      this.showTabSummer = true;
      this.showTabWinter = true;
    }
    if (this.tireContract.tireType === TireTypeEnum.SUMMER) {
      this.activeTabSummer = true;
    } else {
      this.activeTabWinter = true;
    }
  }

  private setDefaultTireBrand() {
    tireBrandService.findByName('ブリヂストン')
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          this.tireBrandDefaultOption = res.data.data;
        }
      });
  }

  private loadTireType(tireType: number) {
    if (tireType === TireTypeEnum.SUMMER) {
      return 'enum.tire_type.summer';
    } else if (tireType === TireTypeEnum.WINTER) {
      return 'enum.tire_type.winter';
    } else {
      return null;
    }
  }

  private loadTireScratch(tireScratch: number) {
    const value = this.tireScratchOptions.find((option) => option.value === tireScratch);
    return value ? value.text : null;
  }

  private loadTireIrregularWear(tireIrregularWear: number) {
    const value = this.tireIrregularWearOptions.find((option) => option.value === tireIrregularWear);
    return value ? value.text : null;
  }

  private exportContract() {
    if (this.tireContractList && this.tireContractList.length > 0) {
      // Export multiple contract
      const contractIds: any[] = this.tireContractList.map((contract) => contract.id);
      tireStoringContractService.exportMultiContract(contractIds)
        .then(() => {
          // Do nothing
        }); 
    } else {
      // Export 1 contract
      if (!this.tireContract.id) {
        return;
      }
      tireStoringContractService.exportContract(this.tireContract.id)
        .then(() => {
          // Do nothing
        });  
    }
    // // Print file
    // printJS(tireStoringContractService.getContractUrl(this.tireContract.id));
  }

  private goBack() {
    this.$emit('loadComponent', new DataBus({
      event: 'image_edit',
      data: {
        isGoBack: true
      }
    }));
  }

  private goToHome() {
    this.$emit('loadComponent', new DataBus({
      event: 'home',
    }));
  }

  private registerAndGoBack() {
    this.$emit('loadComponent', new DataBus({
      event: 'save_and_regiter',
    }));
  }

  private register() {
    this.$emit('loadComponent', new DataBus({
      event: 'confirm_term',
    }));
  }

  private cancelEdit() {
    if (this.isEdit) {
      this.$emit('loadComponent', new DataBus({
        event: 'cancel_edit',
      }));
    }
  }

  private saveContract() {
    if (this.isEdit) {
      if (this.isSwitch) {
        this.$emit('loadComponent', new DataBus({
          event: 'confirm_term',
        }));
      } else {
        this.$emit('loadComponent', new DataBus({
          event: 'save_edit',
        }));
      }
    }
  }

  private cancelRegister() {
    if (!this.isEdit) {
      this.$emit('loadComponent', new DataBus({
        event: 'cancel_register',
      }));
    }
  }

  private showAllScratchImage() {
    if (this.tabIndex === 0 && (this.$refs.tireSummerCard as any)) {
      (this.$refs.tireSummerCard as any).forEach((item: any) => {
        item.showScratchImage = !item.showScratchImage;
      });
    } else if ((this.$refs.tireSummerCard as any)) {
      (this.$refs.tireWinterCard as any).forEach((item: any) => {
        item.showScratchImage = !item.showScratchImage;
      });
    }
  }

}
